<template>
	<!-- 商品規格書ダウンロード -->
	<div class="itemStdListDl" v-if="ptInitData.itemStdFlg == 1">
		<button class="btnSuccess btnItemStdDl" @click="itemStdListDl(ptInitData.productInfo.S_ITEM_NO, '284')">
			<!-- ダウンロードボタン -->
			<div class="itemStdDlLabel">{{ $t('pt125.buttons.itemStdDlLabel') }}</div>
			<div class="itemStdDlInfo">{{ $t('pt125.messages.itemStdDlInfo') }}</div>
		</button>
	</div>
</template>
<script>
export default {
	name: 'itemStdListDl',
	props: {
		ptInitData: {
			type: Object,
			default: null
		}
	},
	methods: {
		itemStdListDl: function(itemNo, programId) {
			var _this = this
			_this.$emit('itemStdListDl',itemNo, programId)
		}
	}
}
</script>